import React from 'react';
import DocumentItem from 'features/shared/documents/components/DocumentItem';
import { Document } from 'core/types';
import { isImageFileUrl } from 'core/util';

interface DocumentsGridViewProps {
  documents: Document[];
  onDocumentClick: (document: Document) => void;
}

const DocumentsGridView: React.FC<DocumentsGridViewProps> = ({
  documents,
  onDocumentClick
}) => {
  const nonImageDocuments = documents.filter(
    (doc) => !isImageFileUrl(doc.file_url)
  );
  const imageDocuments = documents.filter((doc) =>
    isImageFileUrl(doc.file_url)
  );

  return (
    <section id="hk-digital-document-grid">
      {/* Non-image documents section */}
      {nonImageDocuments.map((document: Document, i: number) => (
        <DocumentItem
          key={`doc-${i}`}
          document={document}
          onClick={onDocumentClick}
        />
      ))}

      {/* Images section */}
      <div className="hk-digital-document-grid-images">
        {imageDocuments.map((document: Document, i: number) => {
          const { name, file_url } = document;
          return (
            <img
              key={`img-${i}`}
              className="hk-digital-document-grid-img"
              src={file_url}
              alt={name}
              onClick={() => onDocumentClick(document)}
              style={{ cursor: 'pointer' }}
            />
          );
        })}
      </div>
    </section>
  );
};

export default DocumentsGridView;
